import { useEffect } from "react";

import { useSearchParams } from "react-router-dom";

import { SearchParam } from "../types";

const modulo = (dividend: number, divisor: number) => ((dividend % divisor) + divisor) % divisor;

export const useSimulateTabFocusInApp = () => {
  const [search] = useSearchParams();

  useEffect(() => {
    const handleTab = (event: KeyboardEvent) => {
      if (event.key === "Tab") {
        const inputs = [
          ...document.querySelectorAll('input, select, textarea, button, [contenteditable="true"]'),
        ] as HTMLInputElement[];
        const activeInputs = inputs.filter((input) => input.tabIndex >= 0);
        //@ts-expect-error we handle if its null
        const index = activeInputs.indexOf(document.activeElement);
        if (index !== -1) {
          event.preventDefault();
          const nextIndex = modulo(index + (event.shiftKey ? -1 : 1), activeInputs.length);
          activeInputs[nextIndex].focus();
        }
      }
    };

    if (search.get(SearchParam.InApp) === "true") {
      document.addEventListener("keydown", handleTab);
      return () => document.removeEventListener("keydown", handleTab);
    }
  }, [search]);
};
